import { Popover as MantinePopover } from '@mantine/core';

export const Popover = MantinePopover.extend({
	defaultProps: {
		closeOnClickOutside: false,
		closeOnEscape: false,
		withArrow: true,
		withinPortal: false,
		arrowOffset: 30,
		arrowSize: 30,
		arrowPosition: 'side',
		middlewares: { shift: { padding: 8 } },
		trapFocus: true,
		returnFocus: false,
	},
});
